import { createSelector } from '@reduxjs/toolkit'

import { selectBusinessPrioritiesUserInfo } from './selectBusinessPrioritiesUserInfo'

export const selectBusinessPrioritiesViewType = createSelector(
  [selectBusinessPrioritiesUserInfo],
  (userInfo) => userInfo?.viewType
)
